import React, { useState, useEffect } from "react";
import { Checkbox, Typography, Result, Spin, message } from "antd";
import { useNavigate } from "react-router-dom";
import { apiRoutes, environment } from "../../auth/apiRoute";

import Axios from "axios";
const { Title } = Typography;
export default function Apply(props) {
  const [pendingApproval, setPendingApproval] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    console.log(props);
    if (!props.isAuthenticated) {
      return navigate("/login?next=/judge/apply");
    }

    if (!props.user.firstName) {
      // return navigate("/judge/profile");
    }
    console.log(props.user.judgePendingApproval);
    setPendingApproval(props.user.judgePendingApproval);
  }, []);
  function onChange(e) {
    console.log(props.user);
    console.log(`checked = ${e.target.checked}`);
    setLoading(true);
    if (e.target.checked) {
      console.log(props.user);
      applyForJudge();
    }
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }
  const applyForJudge = async () => {
    setLoading(true);

    try {
      const response = await Axios.post(apiRoutes[environment].applyforjudge, {
        user: props.user,
      });

      if (response.status == 200) {
        setPendingApproval(true);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };
  const appliedForJudge = () => {
    return (
      <Result
        status="success"
        title="Thank you!"
        subTitle="You have applied as Big Apple Stars Awards Judge. Currently, it's pending approval."
        //   extra={[
        //     <Button type="primary" key="console">
        //       Go Console
        //     </Button>,
        //     <Button key="buy">Buy Again</Button>,
        //   ]}
      />
    );
  };
  const approvedForJudge = () => {
    return (
      <Result
        status="success"
        title="Thank you!"
        subTitle="You are a Big Apple Stars Awards Judge."
        //   extra={[
        //     <Button type="primary" key="console">
        //       Go Console
        //     </Button>,
        //     <Button key="buy">Buy Again</Button>,
        //   ]}
      />
    );
  };

  const result = () => {
    if (props.user && props.user.roles && props.user.roles.includes("judge")) {
      return approvedForJudge();
    }
    if (pendingApproval) {
      return appliedForJudge();
    }

    return (
      <Checkbox
        onChange={onChange}
        style={{
          fontSize: "24px",
          transform: "translateY(-50%)",
          position: "relative",
          top: "50%",
        }}
      >
        I'm applying for the judge.
      </Checkbox>
    );
  };
  return (
    <div style={{ padding: " 2rem" }}>
      <Title level={3}> BIG APPLE STARS AWARDS NOMINATION ONLINE JUDGE</Title>
      <Spin spinning={loading}>
        <div style={{ width: "400px", margin: "auto", height: "50vh" }}>
          {result()}
        </div>
      </Spin>
    </div>
  );
}
